import React, { useState } from "react";

import { Link } from "react-router-dom";

import MuiDrawer from "@mui/material/Drawer";
import { styled, useTheme } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

import dropBuyIcon from '../img/dropBuyIcon.svg';
import profileIcon from "../img/circular-profile-icon.svg";
import homeIcon from "../img/circular-home-icon.svg";
import honeycombIcon from "../img/circular-honeycomb-icon.svg";
import adminIcon from "../img/circular-admin-tools-icon.svg";
import hexaBgDrawer from "../img/hexa-bg-drawer.svg";
import menuIcon from "../img/icons/menu.svg";
import honeypotIcon from '../img/icons/honeypot-icon.svg'
import swarmAdminIcon from '../img/swarm-admin-icon.svg'
import swarmBeeIcon from '../img/icons/circular-swarm-icon.svg'

import TermsAndConditionsReadOnly from "./TermsAndConditions/TermsAndConditionsReadOnly";

import { Button } from "@mui/material";
import { UserType } from "../constants/enums";
import AllowedAccess from "./AllowedAccess";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  backgroundColor: "var(--greyblue)",
  backgroundImage: `url(${hexaBgDrawer})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "bottom, center",
  backgroundSize: "400px",
  zIndex: "1",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
  backgroundColor: "var(--greyblue)",
  backgroundImage: `url(${hexaBgDrawer})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "bottom, center",
  backgroundSize: "400px",
  zIndex: "1",
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MainDrawer({ user }) {
  const menuLinks = [
    {
      "text": "My Hive",
      "icon": (
        <img 
          src={homeIcon} 
          alt="Profile Icon" 
          height="64px" 
          width="64px" 
        />
      ),
      "link": "/dashboard/home",
      "id": "NavBar-MyHive-button",
    },
    {
      text: "Swarms",
      icon: (
        <img src={swarmBeeIcon} alt="Honeycomb Icon" height="64px" width="64px" />
      ),
      link: "/dashboard/swarms",
      id: "NavBar-Swarms-button",
    },
    {
      text: "Honeycomb",
      icon: (
        <img src={honeycombIcon} alt="Honeycomb Icon" height="64px" width="64px" />
      ),
      link: "/dashboard/jobs",
      id: "NavBar-Honeycomb-button",
    },
    {
      text: "DropBuy",
      icon: (
        <img
          src={dropBuyIcon}
          alt="Profile Icon"
          height="64px"
          width="64px"
          className="icon-dashboard"
        />
      ),
      link: "/dashboard/DropBuy",
      id: "NavBar-DropBuy-button",
    },
    {
      text: "Resources",
      icon: (
        <img
          src={menuIcon}
          alt="Resources Icon"
          height="64px"
          width="64px"
          className="icon-dashboard"
        />
      ),
      link: "/dashboard/resources",
      id: "NavBar-Resources-button",
    }
  ];

  const SwarmAdmin = () => {
    return (
      <div>
        <ListItem button key={adminIcon} id="NavBar-SwarmsAdmin-button" style={{ padding:'0 16px', margin:'0 0 2em 0' }}>
          <ListItemText className="item-dashboard">
            <Link to="/dashboard/adminswarm" className="link-sidebar">
              <img
                src={swarmAdminIcon}
                alt="Profile Icon"
                height="64px"
                width="64px"
                className="icon-dashboard"
              />

              <p style={{ margin: "0 0 0 0.5em", fontSize: "1.25rem" }}>Swarm Admin</p>
            </Link>
          </ListItemText>
        </ListItem>
      </div>
    );
  };

  const MenuAdmin = () => {
    return (
      <div className="side-bar-admin">
        <ListItem button key={adminIcon} id="NavBar-AdminTools-listItem" style={{ padding:'0 16px' }} >
          <ListItemText className="item-dashboard">
            <Link to="/dashboard/admintools" className="link-sidebar">
              <img
                src={adminIcon}
                alt="Profile Icon"
                height="64px"
                width="64px"
                className="icon-dashboard"
              />

              <p style={{ margin: "0 0 0 0.5em", fontSize: "1.25rem" }}>Admin Tools</p>
            </Link>
          </ListItemText>
        </ListItem>
      </div>
    );
  };

  const PrivacyPolicy = () => {
    return (
      <div className="drawer-privacy-policy" >
        <Button
          href="https://www.encorehive.com/privacy-policy"
          target="_blank" rel="noreferrer"
          sx={{ color: "#ffbd00" }}
        >
          Privacy Policy
        </Button>
      </div>
    );
  };

  const TermsConditions = () => {
    const [openModal, setOpenModal] = useState(false);
    return (
      <div className="drawer-privacy-policy" >
        <Button
          onClick={() => setOpenModal(true)}
          target="_blank" rel="noreferrer"
          sx={{ color: "#ffbd00" }}
        >
          Terms & Conditions
        </Button>

        <TermsAndConditionsReadOnly open={openModal} handleClose={() => setOpenModal(false)} />
      </div>
    );
  };

  const theme = useTheme();
  const [open, setOpen] = React.useState(
    window.innerWidth >= 1280 ? true : false
  );

  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <Drawer variant="permanent" open={open} anchor="left" id="main-drawer">
      <DrawerHeader sx={{ marginTop: "5em" }}>
        <IconButton onClick={handleOpen}>
          {open ? (
            <ChevronLeftIcon sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
          ) : (
            <ChevronRightIcon sx={{ color: "rgba(255, 255, 255, 0.5)" }} />
          )}
        </IconButton>
      </DrawerHeader>

      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >

        <div className="side-bar-buttons">
          {menuLinks.map((Icon, index) => {

            if (user.role !== "Admin" && !user.userDistribution && Icon.link === "/dashboard/DropBuy") return null
            if (user.role !== "Admin" && !user.userDistribution && Icon.link === "/dashboard/resources") return null
            if(!user.useSwarm && Icon.link== "/dashboard/swarms") return null

            return (
              <ListItem button key={Icon.link} style={{ padding:'0 16px' }} id={Icon.id}>
                <ListItemText className="item-dashboard ">
                  <Link to={Icon.link} className="link-sidebar">
                    {Icon.icon}

                    <p style={{ margin: "0 0 0 0.5em", fontSize: "1.25rem" }}>
                      {Icon.text}
                    </p>
                  </Link>
                </ListItemText>
              </ListItem>
            )
          })}
        </div>

        <div>
          <AllowedAccess roles={["Admin"]}>
            <MenuAdmin />

            <AllowedAccess notAllow={true} userTypes={[UserType.HiveAdmin]}>
              <SwarmAdmin />
            </AllowedAccess>
          </AllowedAccess>
          
          {open && (<PrivacyPolicy />)}
          {open && (<TermsConditions />)}

        </div>

      </div>
    </Drawer>
  );
}
